// extracted by mini-css-extract-plugin
module.exports = {"list":"alertList_list__25j3H"};